import EsusView from 'components/esus/EsusView'

export default function ProcedimentosConsolidadosView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoProcedimentosConsolidados' />
}
